import { useEffect, useState } from "react";
import "./news.css";

export default function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filter, setFilter] = useState("all");

  const API_KEY = "pub_133b904819db42bf8cb51f67cc4e10ca";

  const fetchNews = async (category) => {
    setLoading(true);
    setError("");

    // Build query for medical/pharma related news
    let query = "pharma";
    
    if (category === "industry") query = "pharmaceutical industry";
    if (category === "healthcare") query = "healthcare";
    if (category === "regulatory") query = "FDA drug approval";
    if (category === "career") query = "pharma jobs";

    try {
      const response = await fetch(
        `https://newsdata.io/api/1/latest?apikey=${API_KEY}&q=${encodeURIComponent(query)}&language=en`
      );
      const data = await response.json();

      if (data.status === "success" && data.results) {
        const formattedNews = data.results
          .filter((art) => art.title && art.title !== "[Removed]")
          .map((art, index) => ({
            id: index,
            title: art.title,
            description: art.description || "Click to read more...",
            image_url: art.image_url,
            url: art.link,
            category: category,
            publishedAt: art.pubDate,
            source: art.source_id || "News"
          }));
        setNews(formattedNews);
      } else {
        setNews([]);
      }
    } catch (err) {
      console.error("Failed to load news", err);
      setError("Failed to load news: " + (err.message || "Please try again later"));
      setNews([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews(filter);
  }, [filter]);

  return (
    <div className="news-page">
      {/* Header */}
      <div className="news-header">
        <h1>Pharma & Medical News</h1>
        <p className="tagline-animate">Your single source for verified pharma and medical insights</p>
      </div>

      {/* Category Filter Buttons */}
      <div className="filter-bar">
        <button
          onClick={() => setFilter("all")}
          className={filter === "all" ? "active" : ""}
        >
          All
        </button>
        <button
          onClick={() => setFilter("industry")}
          className={filter === "industry" ? "active" : ""}
        >
          Industry News
        </button>
        <button
          onClick={() => setFilter("healthcare")}
          className={filter === "healthcare" ? "active" : ""}
        >
          Healthcare
        </button>
        <button
          onClick={() => setFilter("regulatory")}
          className={filter === "regulatory" ? "active" : ""}
        >
          Regulatory News
        </button>
        <button
          onClick={() => setFilter("career")}
          className={filter === "career" ? "active" : ""}
        >
          Career News
        </button>
      </div>

      {/* Error State */}
      {error && <p className="error-text" style={{ color: '#dc2626', textAlign: 'center', padding: '20px' }}>{error}</p>}

      {/* Loading State */}
      {loading && <p className="loading-text">Loading latest medical news...</p>}

      {/* Empty State */}
      {!loading && !error && news.length === 0 && (
        <p className="empty-text">No news available at the moment. Please check back later.</p>
      )}

      {/* News Grid */}
      {!loading && !error && news.length > 0 && (
        <div className="news-grid">
          {news.map((item) => (
            <div className="news-card" key={item.id}>
              {item.image_url ? (
                <img src={item.image_url} alt={item.title} />
              ) : (
                <div className="no-image">No Image</div>
              )}
              <div className="news-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                  {item.url && (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                      className="read-more"
                    >
                      Read full article &rarr;
                    </a>
                  )}
                  <span style={{ fontSize: '0.8rem', color: '#64748b' }}>
                    {item.publishedAt ? new Date(item.publishedAt).toLocaleDateString() : ''} {item.source && `| ${item.source}`}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}